// extracted by mini-css-extract-plugin
export var chip = "_5s-9";
export var chipLabel = "_5s-a";
export var close = "_5s-7";
export var closeIcon = "_5s-8";
export var error = "_5s-6";
export var infoTooltip = "_5s-2";
export var innerContainer = "_5s-1";
export var input = "_5s-b";
export var medium = "_5s-5";
export var outerContainer = "_5s-0";
export var small = "_5s-4";
export var xSmall = "_5s-3";